"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: merchant/merchant-service.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fmerchant%2Fmerchant-service.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.MerchantServiceClient = exports.ListBlockedResponse = exports.ListBlockedRequest = exports.UnblockResponse = exports.UnblockRequest = exports.BlockResponse = exports.BlockRequest = exports.SubmitReportsResponse = exports.SubmitReportsRequest = exports.MerchantLocationReport = exports.LookupMerchantResponse = exports.LookupMerchantRequest = void 0;
/* eslint-disable */
const rpc_1 = require("@getstep/proto-lib/rpc");
const geo_location_1 = require("../common/geo-location");
const merchant_1 = require("../common/merchant");
const merchant_common_1 = require("./merchant-common");
const protobufPackage = 'com.step.merchant.proto';
function createBaseLookupMerchantRequest() {
    return { locationId: '' };
}
exports.LookupMerchantRequest = {
    fromJSON(object) {
        const message = {
            locationId: isSet(object.locationId) ? globalThis.String(object.locationId) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.locationId !== '') {
            obj.locationId = message.locationId;
        }
        return obj;
    },
    create(base) {
        return exports.LookupMerchantRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseLookupMerchantRequest();
        message.locationId = object.locationId ?? '';
        return message;
    },
};
function createBaseLookupMerchantResponse() {
    return { merchant: merchant_1.Merchant.fromPartial({}) };
}
exports.LookupMerchantResponse = {
    fromJSON(object) {
        const message = {
            merchant: isSet(object.merchant)
                ? merchant_1.Merchant.fromJSON(object.merchant)
                : merchant_1.Merchant.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.merchant !== undefined) {
            obj.merchant = merchant_1.Merchant.toJSON(message.merchant);
        }
        return obj;
    },
    create(base) {
        return exports.LookupMerchantResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseLookupMerchantResponse();
        message.merchant = (object.merchant !== undefined && object.merchant !== null)
            ? merchant_1.Merchant.fromPartial(object.merchant)
            : merchant_1.Merchant.fromPartial({});
        return message;
    },
};
function createBaseMerchantLocationReport() {
    return { paymentId: '', reportedAtMs: '0', geolocation: geo_location_1.UserGeolocation.fromPartial({}) };
}
exports.MerchantLocationReport = {
    fromJSON(object) {
        const message = {
            paymentId: isSet(object.paymentId) ? globalThis.String(object.paymentId) : '',
            reportedAtMs: isSet(object.reportedAtMs) ? globalThis.String(object.reportedAtMs) : '0',
            geolocation: isSet(object.geolocation)
                ? geo_location_1.UserGeolocation.fromJSON(object.geolocation)
                : geo_location_1.UserGeolocation.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.paymentId !== '') {
            obj.paymentId = message.paymentId;
        }
        if (message.reportedAtMs !== '0') {
            obj.reportedAtMs = message.reportedAtMs;
        }
        if (message.geolocation !== undefined) {
            obj.geolocation = geo_location_1.UserGeolocation.toJSON(message.geolocation);
        }
        return obj;
    },
    create(base) {
        return exports.MerchantLocationReport.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseMerchantLocationReport();
        message.paymentId = object.paymentId ?? '';
        message.reportedAtMs = object.reportedAtMs ?? '0';
        message.geolocation = (object.geolocation !== undefined && object.geolocation !== null)
            ? geo_location_1.UserGeolocation.fromPartial(object.geolocation)
            : geo_location_1.UserGeolocation.fromPartial({});
        return message;
    },
};
function createBaseSubmitReportsRequest() {
    return { reports: [] };
}
exports.SubmitReportsRequest = {
    fromJSON(object) {
        const message = {
            reports: globalThis.Array.isArray(object?.reports)
                ? object.reports.map((e) => exports.MerchantLocationReport.fromJSON(e))
                : [],
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.reports?.length) {
            obj.reports = message.reports.map((e) => exports.MerchantLocationReport.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.SubmitReportsRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSubmitReportsRequest();
        message.reports = object.reports?.map((e) => exports.MerchantLocationReport.fromPartial(e)) || [];
        return message;
    },
};
function createBaseSubmitReportsResponse() {
    return {};
}
exports.SubmitReportsResponse = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.SubmitReportsResponse.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseSubmitReportsResponse();
        return message;
    },
};
function createBaseBlockRequest() {
    return { enrichedId: '' };
}
exports.BlockRequest = {
    fromJSON(object) {
        const message = {
            enrichedId: isSet(object.enrichedId) ? globalThis.String(object.enrichedId) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.enrichedId !== '') {
            obj.enrichedId = message.enrichedId;
        }
        return obj;
    },
    create(base) {
        return exports.BlockRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseBlockRequest();
        message.enrichedId = object.enrichedId ?? '';
        return message;
    },
};
function createBaseBlockResponse() {
    return { blocked: merchant_common_1.BlockedMerchant.fromPartial({}) };
}
exports.BlockResponse = {
    fromJSON(object) {
        const message = {
            blocked: isSet(object.blocked)
                ? merchant_common_1.BlockedMerchant.fromJSON(object.blocked)
                : merchant_common_1.BlockedMerchant.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.blocked !== undefined) {
            obj.blocked = merchant_common_1.BlockedMerchant.toJSON(message.blocked);
        }
        return obj;
    },
    create(base) {
        return exports.BlockResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseBlockResponse();
        message.blocked = (object.blocked !== undefined && object.blocked !== null)
            ? merchant_common_1.BlockedMerchant.fromPartial(object.blocked)
            : merchant_common_1.BlockedMerchant.fromPartial({});
        return message;
    },
};
function createBaseUnblockRequest() {
    return { enrichedId: '' };
}
exports.UnblockRequest = {
    fromJSON(object) {
        const message = {
            enrichedId: isSet(object.enrichedId) ? globalThis.String(object.enrichedId) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.enrichedId !== '') {
            obj.enrichedId = message.enrichedId;
        }
        return obj;
    },
    create(base) {
        return exports.UnblockRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseUnblockRequest();
        message.enrichedId = object.enrichedId ?? '';
        return message;
    },
};
function createBaseUnblockResponse() {
    return {};
}
exports.UnblockResponse = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.UnblockResponse.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseUnblockResponse();
        return message;
    },
};
function createBaseListBlockedRequest() {
    return {};
}
exports.ListBlockedRequest = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.ListBlockedRequest.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseListBlockedRequest();
        return message;
    },
};
function createBaseListBlockedResponse() {
    return { merchants: [] };
}
exports.ListBlockedResponse = {
    fromJSON(object) {
        const message = {
            merchants: globalThis.Array.isArray(object?.merchants)
                ? object.merchants.map((e) => merchant_common_1.BlockedMerchant.fromJSON(e))
                : [],
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.merchants?.length) {
            obj.merchants = message.merchants.map((e) => merchant_common_1.BlockedMerchant.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.ListBlockedResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseListBlockedResponse();
        message.merchants = object.merchants?.map((e) => merchant_common_1.BlockedMerchant.fromPartial(e)) || [];
        return message;
    },
};
/**
 * Merchant Service API.
 *
 * Used by client to lookup/report merchant information.
 */
class MerchantServiceClient {
    rpc;
    name = 'com.step.merchant.proto.MerchantService';
    type = rpc_1.ServiceType.PUBLIC;
    path = '/merchant';
    methods = [{
            name: 'LookupMerchant',
            requestType: exports.LookupMerchantRequest,
            responseType: exports.LookupMerchantResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'SubmitReports',
            requestType: exports.SubmitReportsRequest,
            responseType: exports.SubmitReportsResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'ListBlocked',
            requestType: exports.ListBlockedRequest,
            responseType: exports.ListBlockedResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'Block',
            requestType: exports.BlockRequest,
            responseType: exports.BlockResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.STRONG },
        }, {
            name: 'Unblock',
            requestType: exports.UnblockRequest,
            responseType: exports.UnblockResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.STRONG },
        }];
    constructor(rpc) {
        this.rpc = rpc;
    }
    /**
     * Looks up merchant by location id.
     */
    lookupMerchant(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[0],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Submit merchant location details in a batch.
     */
    submitReports(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[1],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Returns a list of blocked merchants.
     */
    listBlocked(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[2],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Adds a blocking for a merchant.
     */
    block(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[3],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Removes a block for a merchant.
     */
    unblock(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[4],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
}
exports.MerchantServiceClient = MerchantServiceClient;
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=merchant-service.js.map